export default "__VITE_ASSET__BcQXj7D7__"